import React from 'react'
import { MokuNotePanel, GetInfoCard } from '../../shared'
import { Button } from '../../generic'
import trophyImage from '../../../images/trophy.jpeg'
import moment from 'moment'

/**
 * CTA for getting a new credit worthiness assessment
 * @param {Function} onGetAssessment - Handler for when user clicks to get assessment
 * @param {Object} mostRecentAssessment - Most recent completed assessment (optional)
 */
export function GetAssessmentCTA({ onGetAssessment, mostRecentAssessment }) {
  const hasOldAssessment = !!mostRecentAssessment

  const title = hasOldAssessment
    ? "Time for an updated Credit Worthiness Assessment?"
    : "Want to know how creditworthy you really are?"

  const getDescription = () => {
    if (hasOldAssessment) {
      const lastAssessmentDate = moment(mostRecentAssessment.applicationDate).format('MMMM YYYY')
      return `Your last assessment was in ${lastAssessmentDate}. We know that circumstances change all the time, so you can get an updated report for just R99. See where you stand now, how lenders view you, and get clear tips to improve your financial health.`
    }
    return "Get your personalised Credit Worthiness Assessment for just R99. See where you stand, how lenders view you, and get clear tips to improve your financial health."
  }

  return (
    <>
      <p/>
      <MokuNotePanel
        title={title}
        description={getDescription()}
      >
        <center style={{ width: '100%' }}>
          <p />
          <Button onClick={onGetAssessment}>
            Get My Assessment
          </Button>
        </center>
        <p />
      </MokuNotePanel>
    </>
  )
}

/**
 * CTA for completing payment on an awaiting payment assessment
 */
export function AwaitingPaymentCTA({ onPayNow }) {
  return (
    <>
      <p/>
      <MokuNotePanel
        title="Your assessment is ready!"
        description="We have prepared your Credit Worthiness Assessment to help you understand how likely you are to get a loan. Please complete your payment to view it."
      >
        <center style={{ width: '100%' }}>
          <p />
          <Button onClick={onPayNow}>
            Pay Now
          </Button>
        </center>
        <p />
      </MokuNotePanel>
    </>
  )
}

/**
 * CTA for viewing completed assessments
 */
export function ViewAssessmentsCTA({ onViewAssessments }) {
  return (
    <>
      <p/>
      <GetInfoCard
        title="View Your Credit Worthiness Assessments"
        description="You have completed assessments. View them to understand how likely you are to get a loan."
        image={trophyImage}
        onClick={onViewAssessments}
      />
    </>
  )
}
